import { isNil } from 'lodash';
import { ItineraryPoint } from 'app/global/class/itinerary-point';

export function isPointValid(point: ItineraryPoint): boolean {
    return !isNil(point) && !isNil(point.coordinates) && !(isNil(point.coordinates.latitude) || isNil(point.coordinates.longitude));
}
